<div class="page-head">
  <h1>Dashboard</h1>
  <p class="muted">Everything that needs your attention.</p>
</div>

@if (loading()) {
  <p class="muted">Loading…</p>
} @else if (error(); as message) {
  <div class="error-banner">{{ message }}</div>
} @else {
  <div class="stats">
    <div class="stat">
      <span class="num">{{ needsQuote().length }}</span>
      <span class="label">Need your quote</span>
    </div>
    <div class="stat">
      <span class="num">{{ awaitingShop().length }}</span>
      <span class="label">Awaiting the shop</span>
    </div>
    <div class="stat">
      <span class="num">{{ toShip().length }}</span>
      <span class="label">Paid — to ship</span>
    </div>
  </div>

  <section class="panel">
    <header class="panel-head">
      <h2>Needs your quote</h2>
      @if (needsQuote().length) {
        <span class="count">{{ needsQuote().length }}</span>
      }
    </header>
    @if (needsQuote().length === 0) {
      <p class="muted">Nothing waiting here.</p>
    } @else {
      @for (item of needsQuote(); track item.customerId) {
        <a class="row" [routerLink]="link(item)">
          <span class="row-name">{{ item.name }}</span>
          <span class="row-meta">{{ item.status }}</span>
          <span class="chev">›</span>
        </a>
      }
    }
  </section>

  <section class="panel">
    <header class="panel-head">
      <h2>Awaiting the shop</h2>
      @if (awaitingShop().length) {
        <span class="count">{{ awaitingShop().length }}</span>
      }
    </header>
    @if (awaitingShop().length === 0) {
      <p class="muted">Nothing waiting here.</p>
    } @else {
      @for (item of awaitingShop(); track item.customerId) {
        <a class="row" [routerLink]="link(item)">
          <span class="row-name">{{ item.name }}</span>
          <span class="row-meta">{{ item.status }}</span>
          <span class="chev">›</span>
        </a>
      }
    }
  </section>

  <section class="panel">
    <header class="panel-head">
      <h2>Paid — ready to ship</h2>
      @if (toShip().length) {
        <span class="count">{{ toShip().length }}</span>
      }
    </header>
    @if (toShip().length === 0) {
      <p class="muted">Nothing waiting here.</p>
    } @else {
      @for (item of toShip(); track item.customerId) {
        <a class="row" [routerLink]="link(item)">
          <span class="row-name">{{ item.name }}</span>
          <span class="row-meta">Add the tracking number</span>
          <span class="chev">›</span>
        </a>
      }
    }
  </section>
}
